export default "__VITE_ASSET__DuueiZz0__"